//use for enumeration
export class FTPAuthenticationType {
    static Password = "password";
    static PublicKey = "publickey";
    static PasswordOrPublicKey = "passwordorpublickey";
    static PasswordAndPublicKey = "passwordandpublickey";
}